export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink py-12">
      <div className="mx-auto flex max-w-content flex-col gap-8 px-6 sm:flex-row sm:items-end sm:justify-between lg:px-8">
        <div>
          <a href="#" className="font-display text-xl font-bold tracking-tight text-bone">
            H<span className="text-copper">barber</span>
          </a>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-mist">
            Sistema para barbearias: agenda, CRM, WhatsApp e caixa.
          </p>
        </div>
        <div className="flex flex-wrap gap-6 text-sm text-mist">
          <a href="#produto" className="hover:text-bone">
            Produto
          </a>
          <a href="#planos" className="hover:text-bone">
            Planos
          </a>
          <a href="/admin/" className="hover:text-bone">
            Entrar
          </a>
        </div>
      </div>
      <div className="mx-auto mt-10 max-w-content px-6 lg:px-8">
        <p className="text-xs text-mist/70">
          © {new Date().getFullYear()} Hbarber. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
